















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { InspectionService } from "@/services/Inspection.service";
import { ShatenService } from "@/services/shaten.service";
@Component({})
export default class DialogFreeOfCharge extends Vue {
  @Prop() public groupCd!: any;
  @Prop() public shatenCd!: any;
  @Prop() public shatenNm!: any;
  @Prop() public kyotenCd!: any;
  @Prop() public kyotenNm!: any;
  @Prop() public version!: any;
  @Prop() public sknInspectSeibiFeeId!: any;
  @Prop() public sknInspectSeibiFeeNm!: any;

  @Watch("groupCd")
  onGroupCdChange(val: any) {
    this.groupCd = val;
  }
  @Watch("shatenCd")
  onShatenCdChange(val: any) {
    this.shatenCd = val;
  }
  @Watch("shatenNm")
  onShatenNmChange(val: any) {
    this.shatenNm = val;
  }
  @Watch("kyotenCd")
  onKyotenCdChange(val: any) {
    this.kyotenCd = val;
  }
  @Watch("kyotenNm")
  onKyotenNmChange(val: any) {
    this.kyotenNm = val;
  }
  @Watch("version")
  onVersionChange(val: any) {
    this.version = val;
  }
  @Watch("sknInspectSeibiFeeId")
  onSknInspectSeibiFeeIdChange(val: any) {
    this.sknInspectSeibiFeeId = val;
  }
  @Watch("sknInspectSeibiFeeNm")
  onSknInspectSeibiFeeNmChange(val: any) {
    this.sknInspectSeibiFeeNm = val;
  }

  loading: boolean = false;
  showDialog: boolean = false;
  data: any = [];
  currentData: any = [];
  currentTypeIndex: any = null;
  currentCateIndex: any = null;
  freeOfChargeNm: string = '無償対応';

  inspectionService: InspectionService = new InspectionService();
  shatenService: ShatenService = new ShatenService();

  open() {
    this.showDialog = true;
    this.currentTypeIndex = null;
    this.currentCateIndex = null;
    this.$nextTick(() => {
      this.getInspection();
    });
  }

  close() {
    this.showDialog = false;
  }

  async getInspection() {
    this.currentData = [];
    this.loading = true;
    const { result } = await this.inspectionService.getInspection(
      this.groupCd, this.shatenCd, this.kyotenCd, this.version
      , this.sknInspectSeibiFeeId, this.currentTypeIndex, this.currentCateIndex
    );
    this.loading = false;
    if (result && result.data) {
      this.data = result.data;
      if (this.data) {
        if(this.data.types && this.data.types.length > 0) {
          if (this.currentTypeIndex == null) {
            if (this.data.types[0].current) {
              this.currentTypeIndex = this.data.types[0].sknInspectTypeId;
            } else {
              this.currentTypeIndex = this.data.types[1].sknInspectTypeId;
            }
          }
        }
        if (this.data.categories && this.data.categories.length > 0) {
          if (this.currentCateIndex == null) {
            this.currentCateIndex = this.data.categories[0].sknInspectCategoryId;
          }
        }
        this.getFreeOfChargeNm();
      }
    }
  }

  async getOsusumeInspection() {
    this.currentData = [];
    this.loading = true;
    const { result } = await this.inspectionService.getOsusumeInspection(
      this.groupCd, this.shatenCd, this.kyotenCd, this.version, this.sknInspectSeibiFeeId, this.currentCateIndex
    );
    this.loading = false;
    if (result && result.data) {
      this.data = result.data;
      if (this.data) {
        if(this.data.types && this.data.types.length > 0) {
          if (this.currentTypeIndex == null) {
            this.currentTypeIndex = this.data.types[0].sknInspectTypeId;
          }
        }
        if (this.data.categories && this.data.categories.length > 0) {
          if (this.currentCateIndex == null) {
            this.currentCateIndex = this.data.categories[0].sknInspectCategoryId;
          }
        }
      }
    }
  }

  mapTree(data: any) {
    let works = [];
    if (data.shakenWork && data.shakenWork.length > 0) {
      works = data.shakenWork.map((work: any) => this.mapShakenWork(work));
    }
    if (this.currentTypeIndex === 99) {
      return works;
    } else {
      return [
        {
          id: data.inspectCd,
          label: data.inspectCd + " " + data.inspectNm,
          isInspect: true,
          isCanDelete: (data.isCanDelete && data.inspectCd > 15000000) ? true : false,
          children: works,
          sknHanyouSeibiVersion: data.sknHanyouSeibiVersion,
          inspectId: data.id,
          inspectCd: data.inspectCd
        }
      ];
    }
  }

  mapShakenWork(work: any) {
    const shWorkNm = work.customWorkNm
      ? `${work.customWorkNm} (${work.workNm})`
      : work.workNm;
    let buhins = [];
    if (work.buhins && work.buhins.length > 0) {
      buhins = work.buhins.map((buhin: any) => this.mapBuhin(buhin));
    }
    return {
      ...work,
      id: work.workId,
      label: work.workCd + " " + shWorkNm,
      isWork: true,
      isExtreme: work.isExtreme == 1,
      isCanEdit: work.workCd != "" ? true : false,
      children: buhins
    };
  }

  mapBuhin(buhin: any) {
    return {
      ...buhin
      , id: buhin.id
      , label: buhin.buhinCd + " " + buhin.buhinNm
    };
  }

  changeInspectType() {
    this.currentCateIndex = null;
    if (this.currentTypeIndex === 99) {
      this.getOsusumeInspection();
    } else {
      this.getInspection();
    }
  }

  selectCategory() {
    if (this.currentTypeIndex === 99) {
      this.getOsusumeInspection();
    } else {
      this.getInspection();
    }
  }

  async getFreeOfChargeNm() {
    this.freeOfChargeNm = '無償対応';
    let data = {
      groupCd: this.groupCd
      , shatenCd: this.shatenCd
      , kyotenCd: this.kyotenCd
      , version: this.version
      , sknInspectSeibiFeeId: this.sknInspectSeibiFeeId
    };
    const response = await this.shatenService.getMSknFreeOfCharge(data);
    if (response && response.freeOfChargeNm && response.freeOfChargeNm.length > 0) {
      this.freeOfChargeNm = response.freeOfChargeNm;
    }
  }
}
